import { registerBlockType } from '@wordpress/blocks';
import { createFeedBlockEdit } from './create-edit';
import './legacy-block-fix';
import '@sb-blocks/styles.css';

import twitterMeta from './twitter/block.json';
import facebookMeta from './facebook/block.json';
import instagramMeta from './instagram/block.json';
import youtubeMeta from './youtube/block.json';
import reviewsMeta from './reviews/block.json';
import tiktokMeta from './tiktok/block.json';
import tiktokIcon from './tiktok/icon';

const blockMetadata = {
	twitter: twitterMeta,
	facebook: facebookMeta,
	instagram: instagramMeta,
	youtube: youtubeMeta,
	reviews: reviewsMeta,
	tiktok: tiktokMeta,
};

const blockIconOverrides = {
	tiktok: tiktokIcon,
};

const configs = window.sbFeedBlocksRegistry || [];
configs.forEach(({ id, localizeVar, initFunction }) => {
	const meta = blockMetadata[id];
	if (!meta) return;
	const iconOverride = blockIconOverrides[id];
	registerBlockType(meta.name, {
		...meta,
		...(iconOverride ? { icon: iconOverride } : {}),
		edit: createFeedBlockEdit({ id, blockName: meta.name, localizeVar, initFunction }),
		save: () => null,
	});
});
